/**
* Created by bieao on 2020/4/2.
*/
<template>
    <div class="item-position runData">
      <div class="runData-title m-b-10">
        <div>塔机信息</div>
        <div>Crane Information</div>
      </div>
      <div class="run-content">
        <div class="width85">
          <div class="run-item">
            <div class="run-img crane m-r-5"></div>
            <div class="run-title">
              <div class="m-b-5">塔机</div>
              <div>{{data.alias}}</div>
            </div>
          </div>
          <div class="run-item">
            <div class="run-img type m-r-5"></div>
            <div class="run-title">
              <div class="m-b-5">
                <span>类型</span>
              </div>
              <div>{{data.craneType === 0 ? '平臂' : (data.craneType === 1 ? '动臂' : '塔头')}}</div>
            </div>
          </div>
          <div class="run-item">
            <div class="run-img height m-r-5"></div>
            <div class="run-title">
              <div class="m-b-5">
                <span>塔高</span>
                <span class="unit m-l-5">m</span>
              </div>
              <div>{{formatter(data.actualTowerHeight)}}</div>
            </div>
          </div>
        </div>
        <div class="width120">
          <div class="run-item">
            <div class="run-img jibLength m-r-5"></div>
            <div class="run-title">
              <div class="m-b-5">
                <span>起重臂</span>
                <span class="unit m-l-5">m</span>
              </div>
              <div>{{formatter(data.jibArmLength)}}</div>
            </div>
          </div>
          <div class="run-item">
            <div class="run-img balanceLength m-r-5"></div>
            <div class="run-title">
              <div class="m-b-5">
                <span>平衡臂</span>
                <span class="unit m-l-5">m</span>
              </div>
              <div>{{formatter(data.actualBalanceArmLength)}}</div>
            </div>
          </div>
          <div class="run-item">
            <div class="run-img sectionLength m-r-5"></div>
            <div class="run-title">
              <div class="m-b-5">
                <span>标准节高</span>
                <span class="unit m-l-5">m</span>
              </div>
              <div>{{formatter(data.actualSectionHeight)}}</div>
            </div>
          </div>
        </div>
        <div class="width280">
          <div class="run-item">
            <div class="run-img rateLoad m-r-5"></div>
            <div class="run-title">
              <div class="m-b-5">
                <span>额定吊重</span>
                <span class="unit m-l-5">t</span>
              </div>
              <div>{{formatter(data.maxLoad, 2)}}</div>
            </div>
          </div>
          <div class="run-item">
            <div class="run-img factory m-r-5"></div>
            <div class="run-title">
              <div class="m-b-5">
                <span>厂商</span>
              </div>
              <div class="factory-name">{{data.craneFactoryName}}</div>
            </div>
          </div>
          <div class="run-item">
            <div class="run-img model m-r-5"></div>
            <div class="run-title">
              <div class="m-b-5">
                <span>型号</span>
              </div>
              <div>{{data.craneModelName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {formatterNumber} from '@/utils/utils'
export default {
  name: 'CraneInformation',
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    formatter () {
      return (val, index) => {
        return formatterNumber(val, index)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .runData{
    background-color: rgba(4,30,48,0.5);
    width: 600px;
    height: 226px;
    left: 1310px;
    top: 844px;
    padding:10px 20px;
    .runData-title{
      font-size: 13px;
      div:last-child{
        color:#5f7f9b;
      }
    }
    .run-content{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width:100%;
      height: 164px;
      & > div{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .run-item{
        display: flex;
        align-items: center;
        .run-img{
          width: 25px;
          height: 25px;
          background-size: 100% 100%;
        }
        .run-title{
          font-size: 13px;
          .unit{
            font-size: 12px;
            color:#6282b4;
          }
          div:last-child{
            font-size: 18px;
            color:#49d5f3;
          }
          .factory-name{
            width: 250px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .crane{
        background:url('/static/img/tubiao-crane.png') center center no-repeat;
      }
      .type{
        background:url('/static/img/tubiao-type.png') center center no-repeat;
      }
      .height{
        background:url('/static/img/tubiao-height.png') center center no-repeat;
      }
      .jibLength{
        background:url('/static/img/tubiao-jibLength.png') center center no-repeat;
      }
      .balanceLength{
        background:url('/static/img/tubiao-balanceLength.png') center center no-repeat;
      }
      .sectionLength{
        background:url('/static/img/tubiao-sectionLength.png') center center no-repeat;
      }
      .rateLoad{
        background:url('/static/img/tubiao-rateLoad.png') center center no-repeat;
      }
      .factory{
        background:url('/static/img/tubiao-factory.png') center center no-repeat;
      }
      .model{
        background:url('/static/img/tubiao-model.png') center center no-repeat;
      }
      .width85{
        width:85px;
      }
      .width120{
        width:120px;
      }
      .width280{
        width:280px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CraneInformation.vue